import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { LinkElement } from '@els/els-react--link-element';

import { isFirstInGroup as isFirstInGroupHelper, highlightQuery as highlightQueryHelper } from './AutosuggestInputHelper';

import './AutosuggestInputDropdown.scss';

export default class AutosuggestInputDropdown extends React.PureComponent {
  selectMatch(index) {
    const { onSelect } = this.props;
    onSelect(index);
  }

  _isFirstInGroup(index) {
    const { matches, groupBy } = this.props;
    return isFirstInGroupHelper({ matches, index, groupBy });
  }

  _highlightMatch(match) {
    const { query } = this.props;
    return highlightQueryHelper({ string: match.title, query });
  }

  render() {
    const { matches, groupBy, highlight } = this.props;

    return (
      <div
        data-e2e="e2e-quick-search-suggest-dropdown"
        className="react-autosuggest-input-dropdown react-autosuggest-input-dropdown--absolute">
        <span className="sr-only">10 search suggestions, use up and down arrow keys to navigate.</span>
        {/* eslint-disable jsx-a11y/click-events-have-key-events,react/no-array-index-key,jsx-a11y/role-has-required-aria-props */}
        <ul
          data-e2e="e2e-quick-search-suggest-list"
          className="e2e-quick-search-suggest-list react-autosuggest-input-dropdown__list"
          role="listbox">
          {matches.map((match, index) => (
            <li
              key={index}
              onClick={() => {
                this.selectMatch(index);
              }}
              role="option">
              {groupBy && this._isFirstInGroup(index) && (
                <div data-e2e="e2e-quick-search-suggest-list-category" className="react-autosuggest-input-dropdown__list__category">
                  <h5>{match[groupBy]}</h5>
                </div>
              )}
              <LinkElement
                data-e2e="e2e-quick-search-suggest-list-item-link"
                href="null"
                navigation
                onClick={(e) => e.preventDefault()}
                className="react-autosuggest-input-dropdown__list__link key-navigatable">
                <InnerHTML
                  tag="span"
                  className="react-autosuggest-input-dropdown__list__link__text u-els-ellipsis"
                  html={highlight ? this._highlightMatch(match) : match.title}
                />
              </LinkElement>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

AutosuggestInputDropdown.propTypes = {
  query: PropTypes.string,
  matches: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  groupBy: PropTypes.string,
  highlight: PropTypes.bool,
};
